import config from './config.js';

class Configuration {
    constructor() {
        if (!Configuration.instance) {
            this.data = { ...config };
            Configuration.instance = this;
        }

        return Configuration.instance;
    }

    loadConfig() {
        return new Promise((resolve) => {
            const configUrl = this.get('configUrl');
            if (configUrl) {
                fetch(configUrl)
                    .then(response => response.json())
                    .then((data) => {
                        this.parseData(data);
                        resolve();
                    })
                    .catch(() => {
                        resolve();
                    });
            } else {
                resolve();
            }
        });
    }

    parseData(data) {
        try {
            if (data.all.api.fincons.mpx_config.account_pid) {
                this.set('accountId', data.all.api.fincons.mpx_config.account_pid);
            }
        } catch (e) {
            console.log('account id does not exist');
        }

        try {
            if (data.all.features.ads) {
                this.set('ads', data.all.features.ads);
            }
        } catch (e) {
            console.log('ads does not exist');
        }

        try {
            if (data.chromecast && data.chromecast.at_analytics.ati_logger_url) {
                this.set('collectDomain', data.chromecast.at_analytics.ati_logger_url);
            }
        } catch (e) {
            console.log('chromecast does not exist');
        }

        try {
            if (data.chromecast && data.chromecast.at_analytics.ati_logger_ssl_url) {
                this.set('collectDomainSSL', data.chromecast.at_analytics.ati_logger_ssl_url);
            }
        } catch (e) {
            console.log('chromecast does not exist');
        }
    }

    set(key, value) {
        this.data[key] = value;
    }

    get(key, valObject) {
        const keys = key.split('.');
        const dataObject = valObject || this.data;

        if (keys.length === 1) {
            if (dataObject[key]) {
                return dataObject[key];
            }
            return undefined;
        }

        if (dataObject[keys[0]]) {
            const nextDataObject = dataObject[keys[0]];
            keys.shift();
            const nextKey = keys.join('.');
            return this.get(nextKey, nextDataObject);
        }
        return undefined;
    }
}

const instance = new Configuration();
Object.freeze(instance);

export default instance;
